import showModal from '@shoflo/studio-redux/actions/modal/showModal/showModal';
import clearNotification from '@shoflo/studio-redux/actions/notification/clearNotification';
import { REALTIME_CONNECTION_TIMEOUT_VALUE } from '@shoflo/polymer/constants/Timeout';
import { LOST_REALTIME_SOCKET_CONNECTION } from 'constants/Modal';
import { StudioLogger } from '@studio/logger/StudioLogger';

const logger = new StudioLogger('socket-dispatcher');

function lostRealTimeMessage(dispatch, getState) {
  const {
    modal,
    meeting: { attendeeResponse }
  } = getState();

  if (!window.realtimeConnectionLostTimeout) {
    window.realtimeConnectionLostTimeout = setTimeout(() => {
      dispatch(clearNotification());

      if (modal?.type) {
        dispatch(showModal(LOST_REALTIME_SOCKET_CONNECTION, modal.type));
      } else {
        dispatch(showModal(LOST_REALTIME_SOCKET_CONNECTION));
      }
    }, REALTIME_CONNECTION_TIMEOUT_VALUE);
  }

  const payload = {
    attendeeId: attendeeResponse?.Attendee?.AttendeeId ?? 'unavailable'
  };
  logger.error('Realtime connection lost', payload);
}

function socketDisconnected({ dispatch, getState }) {
  lostRealTimeMessage(dispatch, getState);
}

export default socketDisconnected;
